/* eslint-disable */
import React, { Component } from 'react'; //different
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { t } from './i18n';
import './i18nMore';
import { OtpEnabled } from './SiteConfig';
class App extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }
    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            stateopterror: "",
            stateregis: 1,
            showpass: true,
            bankselect: 0,
            tblbank: [],
            bankOpen: false,
            trueaccount: true,
            username: null,
            fname: "",
            checkboxacc: 0,
            userid: null,
            phoneNumber: "",
            userrecomend: "",
            linelink: "",
            balance: 0,
            mainacc: null,
        }
        this.forgetotpandregister = this.forgetotpandregister.bind(this);
    }
    notify = (mode, msg) => {
        if (mode == "success") {
            toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }
    confirmdeposit = async (e, num) => {

        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;

        await instance.post("/api/v1/getredeempromotion", {
            userid: Username,
            System: Systems,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                this.setState({
                    proderedeem: res.data.message.tblpromotionredeems,
                });

            }
        }).catch(async (err) => {
        });

        if (num === 0) {
            if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
                const { depositstate } = this.state
                if (num === 0) {
                    if (token != null) {
                        instance.post("/api/v1/getqrcode", {
                            username: Username,
                            System: Systems,
                            amount: this.state.depositamount
                        }, {
                            headers: { Authorization: `Bearer ${token}` }
                        }).then(async (res) => {
                            this.setState({
                                mainacc: res.data.mainacc,
                                qrcode: res.data.tblpaymentgatewayx.QRcode,
                                paymentlist: res.data.tblpaymentgatewayx,
                            });
                        });
                    }

                    this.setState({
                        depositstate: 1
                    });
                }
            }
            else {
                await Swal.fire({
                    title: 'Warning!',
                    text: t(this.lang, 'mr_topup_min') + ' ' + this.state.limit.min + ' ' + t(this.lang, 'mr_baht_max') + ' ' + this.state.limit.max + ' ',
                    icon: 'warning',
                    confirmButtonText: t(this.lang, 'ok')
                })
            }
        }
        else if (num === 1) {
            this.setState({
                depositstate: 1
            });
        }
        else {
            this.setState({
                depositstate: 0
            });
        }



    }
    radiocheck(input) {
        console.log(input);
        this.setState({
            bankselect: input,
            checkboxacc: input
        });
        if (input == 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }
    forgetotpandregister = async (type) => {
        const { phoneNumber, otpphoneforget, bankselect, otpphone, accnumbertxt } = this.state;
        var recheck = false;
        if (type === 4) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 5) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphoneforget,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 6) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 7) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphone,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: accnumbertxt,
                bankid: bankselect,
                System: Systems,
                type: type
            }).then(async (res) => {
                return recheck = res.data.message;

            });
        }
        return recheck
    }
    nextstep = async (e, num) => {
        e.preventDefault();
        const { stateregis, password, bankselect, passwordcf, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state
        console.log(num);
        if (num === 1) {
            const check = await this.forgetotpandregister(6);
            if (phoneNumber.length === 10 && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else {
                if (phoneNumber.length !== 10) {
                    await this.notify("warning", t(this.lang, 'mr_phone_wrong'));
                }
                else if (!check.checked && check.status === 201) {
                    await this.notify("warning", t(this.lang, 'mr_phone_taken'));
                }
                else {
                    await this.notify("warning", t(this.lang, 'mr_too_frequent'));
                    this.setState({
                        stateopterror: t(this.lang, 'mr_too_frequent')
                    });
                }
            }
        }
        else if (num === 2) {

            if (password !== passwordcf) {
                await this.notify("warning", t(this.lang, 'mr_pass_mismatch'));
            }
            else if (password === '') {
                await this.notify("warning", t(this.lang, 'mr_pass_empty'));
            }
            else if (password.length < 6) {
                await this.notify("warning", t(this.lang, 'mr_pass_too_short'));
            }
            else {
                this.setState({
                    stateregis: 3
                });
            }

        }
        else if (num === 3) {
            if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
                this.setState({
                    stateregis: 3
                });
            }
            else {
                await this.notify("warning", t(this.lang, 'mr_select_bank'));
            }
        }
        else if (num === 5) {
            var check = await this.forgetotpandregister(7);
            if (otpphone !== "" && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else if (otpphone === "" || otpphone.length < 4) {
                await this.notify("warning", t(this.lang, 'mr_number_incomplete'));
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }

            else {
                await this.notify("warning", t(this.lang, 'mr_code_wrong'));
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }



        }
        else if (num === 11) {
            console.log(1, stateregis, num);
            this.setState({
                stateregis: 1
            });
        }
        else if (num === 22) {
            this.setState({
                stateregis: 2
            });
        }
        else if (num === 25) {
            console.log("checkboxacc",checkboxacc)
            if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
                this.modalerror({ title: 'error', text: t(this.lang, 'mr_no_account_number') });

            }
            else if (accnumbertxt.length < 10) {
                this.modalerror({ title: 'error', text: t(this.lang, 'mr_check_account_again') });
            }
            else if (checkboxacc === 0) {
                this.modalerror({ title: 'error', text: t(this.lang, 'mr_no_bank_selected') });
            }
            else {
                this.setState({
                    loading: true,
                });
                if (fname === '') {
                    let check = await this.forgetotpandregister(10)
                    if (check.checked) {
                        console.log(302, check.verifications);
                        console.log(302, check.verifications.name);
                        if (check.verifications.status == 0) {
                            this.setState({
                                trueaccount: false,
                            });
                        }
                        else if (check.verifications.status == 1) {
                            this.setState({
                                fname: check.verifications.name,
                            });
                            await this.validatergisterForm(e, check.verifications.name);
                        }
                    }
                    else {
                        this.modalerror({ title: 'error', text: t(this.lang, 'mr_account_invalid') });
                    }
                }
                else {
                    await this.validatergisterForm(e, fname)
                }
                this.setState({
                    loading: false,
                });
            }


        }
    };

    onChangex = event => {


        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "phoneNumber") {
                document.getElementById("phoneNumberforget").style = "";
                document.getElementById("checkotpforgetphone").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }

            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    async modalerror(object) {
        await this.notify(object.title, object.text);
    }
    validatergisterForm = async (e, fname) => {
        e.preventDefault();
        const { phoneNumber, password, passwordcf, checkboxacc, accnumbertxt } = this.state;
        console.log(checkboxacc);
        console.log(this.state)
        if (accnumbertxt === "" || typeof accnumbertxt == "undefined") {
            this.modalerror({ title: 'error', text: t(this.lang, 'mr_no_account_number') });

        }
        else if (fname === "") {

            this.modalerror({ title: 'error', text: t(this.lang, 'mr_no_name') });

        }
        else if (password.length > 15) {
            this.modalerror({ title: 'error', text: t(this.lang, 'mr_pass_max15') });
        }
        else if (password.length < 6) {
            this.modalerror({ title: 'error', text: t(this.lang, 'mr_pass_min15') });
        }
        else if (password != passwordcf) {
            this.modalerror({ title: 'error', text: t(this.lang, 'mr_confirm_mismatch') });
        }
        else {
            await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: checkboxacc,
                accno: accnumbertxt,
                System: Systems,
                Useradvise: this.state.userrecomend
            }).then(async (res) => {
                console.log(res.data);
                if (res.data.status === 200) {
                    await this.modalerror({ title: 'success', text: t(this.lang, 'mr_register_done') });


                    await instance.post("/api/v1/userlogin", {
                        userid: phoneNumber,
                        password: password,
                        System: Systems,
                        Function: 'validateLoginForm-navbar.js'
                    }).then((res) => {
                        if (res.status === 200) {
                            if (res.data.status === 200) {
                                localStorage.setItem('auth_token', res.data.token);
                                setInterval(() =>
                                    window.location.href = '/'
                                    , 4000);

                            }
                        }
                    });
                }
                else if (res.data.status === 203) {
                    this.modalerror({ title: 'error', text: t(this.lang, 'mr_account_registered') });
                }
                else if (res.data.status === 202) {
                    this.modalerror({ title: 'error', text: t(this.lang, 'mr_username_registered') });
                }
                else {
                    this.modalerror({ title: 'error', text: t(this.lang, 'mr_username_invalid') });
                }
            });
        }


    };
    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }
    async saveclickaff(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                this.setState({
                    userrecomend: res.data.username,
                    link: linkid
                });
                var username = res.data.username
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async saveclick(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status == 200) {
                var date = new Date()
                var username = res.data.username
                this.setState({
                    userrecomend: username,
                });
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async componentDidMount() {
        // (เดิมลบ auth_token ตรงนี้ทุกครั้งที่ mount -> ทำให้ logout อัตโนมัติทุกโหลด) เอาออกแล้ว
        const search = window.location.href;
        var test = search.split("aff=")[1]
        if (test != undefined) {
            this.saveclickaff(test.split("&")[0]);
        }
        var params = search.split("reg=")[1]
        if (params != undefined) {
            this.saveclick(params);
            this.setState({
                userrecomend: params.split("&")[0],
            });
        }

        var tokenf = localStorage.getItem('aff');
        if (tokenf != null) {
            var codev = JSON.parse(tokenf)
            var Username = codev.username;
            this.setState({
                userrecomend: Username,
            });
        }

        var tokenx = localStorage.getItem('register');
        if (tokenx != null) {
            codev = JSON.parse(tokenx)
            Username = codev.username;
            this.setState({
                userrecomend: Username,
            });
        }


        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                var min = res.data.tblcatagoryx[0].limitdeposit;
                var max = res.data.tblcatagoryx[0].maxdeposit;
                var limit = { min, max }
                this.setState({
                    linelink: datas[1].value,
                    System: res.data.tblcatagoryx[0].System,
                    limit: limit
                });
                try {
                    this.setState({ tblbank: res.data.tblbank || [] });
                } catch (ex) { }
            }
            else {
            }
        });
    }





    render() {

        const { stateopterror, userrecomend } = this.state
        const lang = this.lang;
        return (
            <div className="-full-flex-wrap ">
                <div
                    className="-full-flex-inner-bg -bg"

                >
                    <div className="x-promotion-index">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="x-page-title-component ">
                                        <div className="-inner-wrapper">
                                            <h1 className="-title">{t(lang, 'register_title')}</h1>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div
                                        className="col order-lg-2 order-0 -form  fadeInRegisterform"
                                    >
                                        <div className="x-modal-separator-container ">
                                            <div className="x-modal-body-base -v3 -phone-number x-form-register-v3" style={{ display: this.state.stateregis === 1 ? "" : "none" }}>
                                                <div className="row -register-container-wrapper -password-body">
                                                    <div className="col">
                                                        <div className="x-title-register-modal-v3 ">
                                                            <span className="-title">{t(lang, 'rg_phone_title')}</span>
                                                            <span className="-sub-title">{OtpEnabled ? t(lang, 'rg_phone_sub') : t(lang, 'rg_phone_sub_nootp')}</span>
                                                        </div>
                                                    </div>
                                                    <div data-animatable="fadeInRegister" className="col animated fadeInRegister">
                                                        <div className="-fake-inner-body">
                                                            <div className="-x-input-icon input-group text-center">
                                                                <input onChange={this.onChangex} type="text" id="phoneNumber" name="phoneNumber" required pattern="[0-9]*" className="form-control x-form-control -username" placeholder="095-123-4567" autoFocus autoComplete="on" inputMode="text" />
                                                                <div id="checkotpforgetphonenormal" className="invalid-feedback "><ul className="list-unstyled mb-0"><li>{stateopterror}</li></ul></div>
                                                            </div>
                                                            {userrecomend ? (
                                                            <div className="-x-input-icon input-group text-center" style={{ marginTop: "12px" }}>
                                                                <input onChange={this.onChangex} readOnly style={{ color: "black", background: "transparent" }} type="text" id="userrecomend" name="userrecomend" value={userrecomend} className="form-control x-form-control" placeholder={t(lang, 'rg_referrer_ph')} autoComplete="on" />
                                                            </div>
                                                            ) : null}
                                                            <div className="-btn-inline-wrapper text-center">
                                                                <button onClick={(e) => { this.nextstep(e, 1) }} type="button" className="btn btn-primary -submit"><span>{t(lang, 'ln_next')}</span></button>
                                                            </div>
                                                            <input type="hidden" id="request_otp__token" name="request_otp[_token]" defaultValue="ds26nEjb1GacmW8racC7ScvGiCgTEnPl5xKWBzZyMWc" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="-top " style={{ display: this.state.stateregis === 5 ? "" : "none" }}>
                                                <h3 className="x-title-modal mx-auto text-center ">
                                                    {t(lang, 'rg_otp_title')}
                                                </h3>
                                                <div className="-img-container ">
                                                    <picture>
                                                        <source
                                                            type="image/webp"
                                                            srcSet="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                                                        />
                                                        <source
                                                            type="image/png?v=5"
                                                            srcSet="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                                                        />
                                                        <img
                                                            alt="กรอกรหัส OTP เพื่อยืนยันตัวตน"
                                                            className="img-fluid -ic-otp"
                                                            width={150}
                                                            height={150}
                                                            src="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                                                        />
                                                    </picture>
                                                </div>

                                                <div className="-fake-inner-body">
                                                    <div className="x-step-register -v2">
                                                        <div className="px-0 m-auto -container-wrapper">
                                                            <div className={"-step-box-outer" + (this.state.stateregis !== 5 ? "" : " step-active")}></div>
                                                            <div className={"-step-box-outer" + (this.state.stateregis !== 5 ? "" : " step-active")}></div>
                                                            <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                            <div className={"-step-box-outer" + (this.state.stateregis !== 3 ? "" : " step-active")}></div>
                                                        </div>
                                                    </div>
                                                    <div >
                                                        <div className="-x-input-icon mb-3 text-center">
                                                            <img
                                                                src="/build/web/igame-index-lobby-wm/img/ic-input-phone.png"
                                                                className="-icon"
                                                                alt="SA Casino phone icon"
                                                                width={10}
                                                                height={14}
                                                            />
                                                            <input
                                                                onChange={this.onChangex}
                                                                type="text"
                                                                id="otpphone"
                                                                name="otpphone"
                                                                required="required"
                                                                pattern="[0-9]*"
                                                                maxLength="4"
                                                                className="x-form-control form-control"
                                                                placeholder={t(lang, 'rg_otp_ph')}
                                                                autoFocus="autoFocus"
                                                                autoComplete="on"
                                                                inputMode="text"
                                                            />
                                                            <div id="checkotp" className="invalid-feedback ">
                                                                <ul className="list-unstyled mb-0"><li>{stateopterror}</li></ul>
                                                            </div>
                                                        </div>
                                                        <div className="text-center">
                                                            <a href="#0" style={{ cursor: "pointer" }}
                                                                onClick={(e) => {
                                                                    this.nextstep(e, 11)
                                                                }} className="text-muted mt-3">
                                                                {t(lang, 'rg_cancel')}
                                                            </a>
                                                        </div>
                                                        <div className="text-center">

                                                            <button
                                                                onClick={(e) => {
                                                                    this.nextstep(e, 5)
                                                                }}
                                                                type="submitx"
                                                                className="btn   btn-primary mt-lg-3 mt-0"
                                                                disabled=""
                                                            >
                                                                {t(lang, 'rg_continue')}
                                                            </button>
                                                        </div>
                                                        <input
                                                            type="hidden"
                                                            id="request_otp__token"
                                                            name="request_otp[_token]"
                                                            defaultValue="ds26nEjb1GacmW8racC7ScvGiCgTEnPl5xKWBzZyMWc"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="-top " style={{ display: this.state.stateregis === 3 ? "" : "none" }}>
                                                <h3 className="x-title-modal mx-auto text-center ">
                                                    {t(lang, 'rg_bank_title')}
                                                </h3>
                                                <div className="-x-input-icon mb-3 text-center">
                                                    <div
                                                        data-animatable="fadeInModal"
                                                        className="-animatable-container animated fadeInModal"
                                                    >
                                                        <div className="text-center -img-container">
                                                            <div className="-title mt-3">{t(lang, 'rg_select_bank')}</div>
                                                        </div>
                                                        <div className="x-step-register -v2">
                                                            <div className="px-0 m-auto -container-wrapper">
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 2 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 2 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 2 ? "" : " step-active")}></div>
                                                                <div className={"-step-box-outer" + (this.state.stateregis !== 1 ? "" : " step-active")}></div>
                                                            </div>
                                                        </div>
                                                        <div id="card-bank-info">
                                                            <div className="text-center">
                                                                <div className="my-3 js-bank-select-container">
                                                                    {(() => {
                                                                        const selectedBank = this.state.tblbank.find(
                                                                            (b) => b.bank_id == this.state.bankselect
                                                                        );
                                                                        return (
                                                                            <div className={"x-bank-dropdown-v3" + (this.state.bankOpen ? " -open" : "")}>
                                                                                <button
                                                                                    type="button"
                                                                                    className="-bank-toggle"
                                                                                    onClick={() => { this.setState({ bankOpen: !this.state.bankOpen }); }}
                                                                                >
                                                                                    {selectedBank ? (
                                                                                        <span className="-selected">
                                                                                            <img className="-logo" src={selectedBank.img_path} alt="" />
                                                                                            <span className="-name">{selectedBank.fullname_th}</span>
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span className="-placeholder">{t(lang, 'rg_select_bank')}</span>
                                                                                    )}
                                                                                    <i className="fas fa-chevron-down -chevron" />
                                                                                </button>
                                                                                {this.state.bankOpen ? (
                                                                                    <div className="-bank-list">
                                                                                        {this.state.tblbank.map((item, i) => (
                                                                                            <div
                                                                                                key={item.bank_id || i}
                                                                                                className={"-bank-option" + (this.state.bankselect == item.bank_id ? " -selected" : "")}
                                                                                                onClick={() => { this.radiocheck(item.bank_id); this.setState({ bankOpen: false }); }}
                                                                                            >
                                                                                                <img className="-logo" src={item.img_path} alt="" />
                                                                                                <span className="-name">{item.fullname_th}</span>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </div>
                                                                <div className="js-bank-number-and-name-container position-relative">
                                                                    <div className="x-bank-info-validate-box -v2">
                                                                        <div className="-content-validate">
                                                                            {t(lang, 'rg_verify1')}
                                                                        </div>
                                                                        <div className="-detail-validate">
                                                                            {t(lang, 'rg_verify2')}
                                                                        </div>
                                                                        <i className="fas fa-arrow-right" />
                                                                    </div>
                                                                    <div className="-x-input-icon mb-3 flex-column">
                                                                        <img
                                                                            className="-icon"
                                                                            alt="กระเป๋าเงิน ฝากถอน ออโต้"
                                                                            width={15}
                                                                            height={15}
                                                                            src="/build/web/igame-index-lobby-wm/img/ic-library-book-v2.png?v=5"
                                                                        />
                                                                        <input
                                                                            type="text"
                                                                            onChange={this.onChangex}
                                                                            id="accnumbertxt"
                                                                            name="accnumbertxt"
                                                                            required="required"
                                                                            pattern="[0-9]*"
                                                                            className="x-form-control form-control"
                                                                            placeholder={t(lang, 'rg_acc_ph')}
                                                                            autoFocus="autoFocus"
                                                                            inputMode="text"
                                                                        />
                                                                    </div>
                                                                    <div className="-x-input-icon mb-3 flex-column" style={{ display: this.state.trueaccount ? "none" : "" }}>
                                                                        <img
                                                                            className="-icon"
                                                                            alt="รองรับการเข้าใช้งานหลายผู้เล่น 24 ชั่วโมง"
                                                                            width={15}
                                                                            height={15}
                                                                            src="/build/web/igame-index-lobby-wm/img/ic-user-v2.png?v=5"
                                                                        />
                                                                        <input
                                                                            type="text"
                                                                            onChange={this.onChangex}
                                                                            value={this.state.fname}
                                                                            id="fname"
                                                                            name="fname"
                                                                            required="required"
                                                                            className="x-form-control form-control"
                                                                            placeholder={t(lang, 'rg_name_ph')}
                                                                        />
                                                                    </div>
                                                                    <div className="-text-hint col-sm-10 m-auto d-block d-lg-none">
                                                                        {t(lang, 'rg_fill_warn')}
                                                                    </div>
                                                                </div>
                                                                <a
                                                                    href="#0"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={(e) => {
                                                                        this.nextstep(e, 11)
                                                                    }} className="text-muted mt-3">
                                                                    {t(lang, 'rg_cancel')}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="hidden"
                                                        id="customer_bank_account__token"
                                                        name="customer_bank_account[_token]"
                                                        defaultValue="EtuWE7npKiT8yTfHa4RNu7uFMEY1cTFVfBKaSda8kGc"
                                                    />

                                                </div>
                                                <div className="text-center">
                                                    <button
                                                        onClick={(e) => {
                                                            this.nextstep(e, 25)
                                                        }}
                                                        type="submitxa"
                                                        className="btn   btn-primary mt-lg-3 mt-0"
                                                        disabled=""
                                                    >
                                                        <div style={{ display: this.state.loading ? "" : "none" }}>
                                                            <span className="spinner-border" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </span>
                                                        </div>
                                                        <div style={{ display: this.state.loading ? "none" : "" }}>
                                                            {t(lang, 'rg_continue')}
                                                        </div>

                                                    </button>
                                                </div>
                                                <input
                                                    type="hidden"
                                                    id="request_otp__token"
                                                    name="request_otp[_token]"
                                                    defaultValue="ds26nEjb1GacmW8racC7ScvGiCgTEnPl5xKWBzZyMWc"
                                                />
                                            </div>
                                            <div className="x-modal-body-base -v3 -password x-form-register-v3" style={{ display: this.state.stateregis === 2 ? "" : "none" }}>
                                                <div className="row -register-container-wrapper -password-body">
                                                    <div className="col">
                                                        <div className="x-title-register-modal-v3 ">
                                                            <span className="-title">{t(lang, 'rg_pass_title')}</span>
                                                            <span className="-sub-title">{t(lang, 'rg_pass_sub')}</span>
                                                        </div>
                                                    </div>
                                                    <div data-animatable="fadeInRegister" className="col animated fadeInRegister">
                                                        <div className="-fake-inner-body">
                                                            <div className="-x-input-icon input-group text-center">
                                                                <input onChange={this.onChangex} type="password" id="password" name="password" className="form-control x-form-control" placeholder={t(lang, 'rg_pass_ph')} autoComplete="new-password" />
                                                            </div>
                                                            <div className="-x-input-icon input-group text-center" style={{ marginTop: "12px" }}>
                                                                <input onChange={this.onChangex} type="password" id="passwordcf" name="passwordcf" className="form-control x-form-control" placeholder={t(lang, 'rg_passcf_ph')} autoComplete="new-password" />
                                                            </div>
                                                            <div className="-btn-inline-wrapper text-center">
                                                                <button type="button" onClick={(e) => { this.nextstep(e, 2) }} className="btn btn-primary -submit"><span>{t(lang, 'ln_next')}</span></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="-bottom ">
                                                <div className="x-admin-contact text-center ">
                                                    <span className="x-text-with-link-component">
                                                        <label className="-text-message ">{t(lang, 'ln_problem')}</label>
                                                        <a
                                                            href={this.state.linelink}
                                                            className="-link-message "
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <u>{t(lang, 'ln_contact_cs')}</u>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        );
    }
}
export default App;
